module.exports = __webpack_public_path__ + "static/langojango-hebrew-language-phrasebook-1300f183744e09e6b8d6a3b07107d00b.png";